import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';
import '../components/Aurora.css';
import Aurora from './Aurora';
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';


function Login() {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${API_BASE}/auth/login`, {
                username,
                password
            });
            localStorage.setItem('token', res.data.token);
            setMessage('Login successful! Redirecting...');

            // Redirect to home page after successful login
            setTimeout(() => {
                navigate('/');
            }, 1000);
        } catch (err) {
            setMessage('Login failed. Check your credentials.');
        }
    };

    return (
        <div className="aurora-container">
            { <Aurora
                colorStops={["#3A29FF", "#ACADBC", "#006A52"]}
                blend={0.5}
                amplitude={1.0}
                speed={0.5}
                />  }
        <div className="login-page">
            <div className="login-container">
                <div className="login-form">
                    <h2 className="login-title">Admin Login</h2>
                    <form onSubmit={handleSubmit} className="login-form-content">
                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <input
                                id="username"
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                placeholder="Enter your username"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Enter your password"
                            />
                        </div>
                        <button type="submit" className="login-button">
                            Login
                        </button>
                    </form>
                    {message && (
                        <div className={`login-message ${message.includes('success') ? 'success' : 'error'}`}>
                            {message}
                        </div>
                    )}
                </div>
            </div>
        </div>
        </div>
    );
}

export default Login;
